var _defs, _circle, _g, _rect, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6,.cls-7{fill:none;}.cls-5,.cls-6,.cls-7{stroke:#fff;}.cls-5,.cls-7{stroke-miterlimit:10;}.cls-5{stroke-width:4px;}.cls-6,.cls-7{stroke-linecap:round;}.cls-6{stroke-miterlimit:10;stroke-width:5px;}.cls-7{stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6-2",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_150",
    "data-name": "Path 150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.73,109.45A51.67,51.67,0,0,1,36.62,10.2,51.65,51.65,0,0,1,93.25,94.32a51.39,51.39,0,0,1-36.52,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.73,8.14A49.67,49.67,0,0,0,37.4,103.55,49.67,49.67,0,0,0,76.05,12a49.26,49.26,0,0,0-19.32-3.9m0-4A53.66,53.66,0,1,1,3.07,57.8,53.66,53.66,0,0,1,56.73,4.14Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    className: "cls-4",
    x: 32.21,
    y: 30.21,
    width: 48.82,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-5",
    d: "M77.06,75a26,26,0,1,1,.85-33.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-6",
    d: "M39.19,57.19A23.27,23.27,0,0,0,46.4,71.6c4.06,4,8.35,5.33,14,5.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-7",
    d: "M70.09,42.31A23.25,23.25,0,0,0,54.23,39.5c-5.61.88-9.26,3.51-13,7.78"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    className: "cls-1",
    x: 49.4,
    y: 52.76,
    width: 12.53,
    height: 12.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    className: "cls-1",
    x: 57.19,
    y: 46.41,
    width: 12.53,
    height: 12.53
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    className: "cls-4",
    x: 32.21,
    y: 30.21,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon8.353ab9daee185af15b1bd634f9fa1932.svg";
export { ForwardRef as ReactComponent };